import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function SendIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M21.175 2.823a1.296 1.296 0 0 0-1.284-.335h-.011L1.89 7.947a1.313 1.313 0 0 0-.201 2.448l8.025 3.801a.195.195 0 0 1 .09.09l3.803 8.025a1.3 1.3 0 0 0 1.182.75c.038 0 .075 0 .114-.003a1.302 1.302 0 0 0 1.152-.945L21.51 4.117V4.11a1.294 1.294 0 0 0-.333-1.285Zm-.75.975-5.45 17.992v.011a.176.176 0 0 1-.165.135.174.174 0 0 1-.188-.106l-3.75-7.909 4.522-4.522a.563.563 0 0 0-.795-.795l-4.519 4.521-7.909-3.75a.188.188 0 0 1 .03-.351h.009L20.202 3.57a.181.181 0 0 1 .18.048.186.186 0 0 1 .048.18h-.003Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
